type LongTouchCallback = (event: TouchEvent) => void

class LongTouchPlugin {
  private readonly longTouchDuration: number
  private touchTimer: any = null
  private touchStartTime = 0
  private callback: LongTouchCallback

  constructor(longTouchDuration: number, callback: LongTouchCallback) {
    this.longTouchDuration = longTouchDuration
    this.callback = callback
  }

  public init(element: HTMLElement): void {
    element.addEventListener('touchstart', this.handleTouchStart.bind(this), false)
    element.addEventListener('touchend', this.handleTouchEnd.bind(this), false)
    element.addEventListener('touchcancel', this.handleTouchEnd.bind(this), false)
  }

  private handleTouchStart(event: TouchEvent): void {
    this.touchStartTime = Date.now()
    this.touchTimer = setTimeout(() => {
      this.triggerLongTouch(event)
    }, this.longTouchDuration)
  }

  private handleTouchEnd(event: TouchEvent): void {
    if (this.touchTimer) {
      clearTimeout(this.touchTimer)
      this.touchTimer = null

      if (Date.now() - this.touchStartTime < this.longTouchDuration) {
        // Short touch detected
      }
    }
  }

  private triggerLongTouch(event: TouchEvent): void {
    if (this.touchTimer) {
      clearTimeout(this.touchTimer)
      this.touchTimer = null
    }
    this.callback(event)
  }
}

export default LongTouchPlugin
